
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MeltingReturnItemsDialog extends Serenity.EntityDialog<MeltingReturnItemsRow, any> {
        protected getFormKey() { return MeltingReturnItemsForm.formKey; }
        protected getIdProperty() { return MeltingReturnItemsRow.idProperty; }
        protected getLocalTextPrefix() { return MeltingReturnItemsRow.localTextPrefix; }
        protected getNameProperty() { return MeltingReturnItemsRow.nameProperty; }
        protected getService() { return MeltingReturnItemsService.baseUrl; }
        protected getDeletePermission() { return MeltingReturnItemsRow.deletePermission; }
        protected getInsertPermission() { return MeltingReturnItemsRow.insertPermission; }
        protected getUpdatePermission() { return MeltingReturnItemsRow.updatePermission; }

        protected form = new MeltingReturnItemsForm(this.idPrefix);
        constructor() {
            super();
            q.HideCategoryLable(this.element);
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            var x = this.form.SubCategoryId.value;
            var y = this.form.CategoryId.value;
            
        }
    }
}